import React from 'react';
import {
  ReferenceInput,
  required,
  SelectInput,
  showNotification,
  TextInput,
  withDataProvider,
  useRefresh,
} from 'react-admin';
import { withRouter } from 'react-router';
import CustomToolbar from '../../components/CustomToolbar';
import AccountFieldForAdmin from '../../components/AccountFieldForAdmin';
import { withStyles } from '@material-ui/core';
import { getAccountId } from '../../token';
import { maxLength } from 'ra-core';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import FormSectionDescription from '../../components/FormSectionDescription';
import StyledSimpleForm from '../../components/StyledSimpleForm';
import CopyToClipboardField from '../../components/CopyToClipboardField';
import PushForConsentAction from '../../components/PushForConsentAction';
const styles = {
  input: {
    marginTop: 0,
    width: '299px'
  },
  sectionTitle: {
    marginBottom: '24px'
  },
  solutionIDTitle: {
    marginTop: '16px'
  },
  fieldWrapper: {
    marginBottom: '16px'
  }
};
const EditCreateForm = (props) => {
  const { classes, save, dataProvider, showNotification, history, cancelUrl, onUpdateSuccess, ...rest } = props;
  const isEdit = !!props.record.id;
  const refresh = useRefresh();

  const updateSolution = async data => {
    try {
      await dataProvider.update('universal_consent_solutions', { id: props.record.id, data });
      showNotification('mobile_consent_solution_save_success');
      const encodedId = encodeURIComponent(props.id);
      onUpdateSuccess();
      history.push(`${props.basePath}/${encodedId}`);
    } catch (error) {
      showNotification('mobile_consent_solution_save_fail',
        'warning',
        {
          messageArgs: {
            message: error.message || ''
          }
        });
    }
  }
  const onPushForConsent = () => refresh();

  const handleSave = (record) => {
    record.description = record.description || '';
    record.type = record.type || '/universal_consent_solution_types/2';
    record.account = record.account || `/accounts/${getAccountId()}`;
    if (isEdit) {
      updateSolution(record);
    } else {
      save(record, (basePath, id) => `${basePath}/${encodeURIComponent(id)}`);
    }
  };
  return (
    <StyledSimpleForm toolbar={<CustomToolbar cancelUrl={cancelUrl} />} save={handleSave} {...rest}>
      {isEdit ? null : <AccountFieldForAdmin className={classes.input} />}

      <div className={classes.sectionTitle}>
        <FormSectionDescription title="Solution details" />
      </div>
      <TextInput
        source="name"
        label="Name"
        validate={required()}
        className={classes.input}
        helperText={false}
      />
      {/*
      this is commented out due to CI-3913 and should be removed in future due to CI-3894
      <TextInput
        source="applicationName"
        label="App name"
        className={classes.input}
        helperText={false}
      />
      */}
      <TextInput
        source="description"
        label="Optional description"
        multiline
        className={classes.input}
        helperText={false}
        validate={maxLength(255, "Description should contain maximum 255 symbols")}
      />
      <ReferenceInput
        label="Type of OS"
        source="mobileOperatingSystem"
        reference="mobile_operating_systems"
        className={classes.input}
        validate={required()}
        disabled={isEdit}
        helperText={false}
      >
        <SelectInput optionText="name" validate={required()} />
      </ReferenceInput>
      {isEdit ?
        <Grid container spacing={5} alignItems="flex-end">
          <Grid item xs={12} sm={6}>
            <div className={`${classes.sectionTitle} ${classes.solutionIDTitle}`}>
              <FormSectionDescription title="Mobile Consent Solution ID" description="Click below to copy it." />
            </div>
            <div className={classes.fieldWrapper}>
              <CopyToClipboardField name="Solution ID" value={props.record.originId} />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={`${classes.sectionTitle} ${classes.solutionIDTitle}`}>
              <FormSectionDescription title="Consent Solution Version ID" description="This is the latest Mobile Consent Version Id that will appear in JSON with consent details." />
            </div>
            <div className={classes.fieldWrapper}>
              <CopyToClipboardField name="Solution Version ID" value={props.record.currentVersionId} />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={`${classes.sectionTitle} ${classes.solutionIDTitle}`}>
              <FormSectionDescription title="Push for consent" description="Show consent pop-up for all visitors and collect a new consent." />
            </div>
            <div className={classes.fieldWrapper}>
              <PushForConsentAction
                onPushForConsent={onPushForConsent}
                consentSolutionId={props.record.originId}
                solutionType='ucs'
              />
            </div>
          </Grid>
        </Grid>
        : null}
    </StyledSimpleForm>
  )
}

export default withStyles(styles)(
  connect(null, { showNotification })(withDataProvider(withRouter(EditCreateForm)))
);
